import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNotifications } from "@/context/NotificationsContext";
import { Megaphone } from "@phosphor-icons/react";

export default function Communications() {
    const [items, setItems] = useState([]);
    const { markCommsRead } = useNotifications();

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/communications");
                setItems(data);
                markCommsRead();
            } catch (e) {
                if (process.env.NODE_ENV !== "production") {
                    console.warn("communications load failed:", e);
                }
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="space-y-6" data-testid="communications-page">
            <div>
                <div className="text-[10px] uppercase tracking-[0.22em] text-muted-foreground">
                    In bacheca
                </div>
                <h1 className="font-display text-4xl md:text-5xl font-black uppercase tracking-tight">
                    Comunicazioni
                </h1>
            </div>
            <div className="space-y-3">
                {items.map((c) => (
                    <div
                        key={c.id}
                        className="rounded-2xl hairline bg-card p-5"
                    >
                        <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-primary">
                            <Megaphone size={14} weight="fill" /> {c.author || "Società"}
                            <span className="text-muted-foreground">·</span>
                            <span className="text-muted-foreground">
                                {new Date(c.created_at).toLocaleDateString("it-IT")}
                            </span>
                        </div>
                        <h3 className="font-display text-xl md:text-2xl font-bold uppercase tracking-tight mt-1">
                            {c.title}
                        </h3>
                        <p className="mt-2 text-sm leading-relaxed whitespace-pre-line text-foreground/90">
                            {c.body}
                        </p>
                    </div>
                ))}
                {items.length === 0 && (
                    <div className="rounded-2xl hairline p-8 text-center bg-card">
                        <div className="text-muted-foreground">Nessuna comunicazione.</div>
                    </div>
                )}
            </div>
        </div>
    );
}
